import axios from "./axiosInstance";

const get = async (path) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(path);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

// "a=1&b=2", leaving out empty values.
export const queryOf = (params) =>
  Object.entries(params || {})
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join("&");

// Warehouse app 0.8.0 (store logins): what was scanned on an order, newest
// first, with the labels scanned of its packages. 403 for warehouse logins.
export const fetchOrderScans = (orderId, warehouseId) =>
  get(`wms/orders/${orderId}/scans?${queryOf({ warehouse_id: warehouseId })}`);

// The warehouses this login works in, with what it may do in each
// (can.orders: its orders there).
export const fetchScanWarehouses = () => get("wms/warehouses");

// The Scans page: every scan in a warehouse for the days and filters, newest
// first, a page at a time (warehouse_id, date_from, date_to, carrier,
// user_id, stage, result, order, page, per_page up to 500).
export const fetchScanReport = (params) => get(`wms/scans?${queryOf(params)}`);

// The carriers with packages to take on a day (labels made that day, and
// open orders' labels of the last days), with how many were logged leaving.
export const fetchPickupCarriers = (warehouseId, date) =>
  get(`wms/pickup/carriers?${queryOf({ warehouse_id: warehouseId, date })}`);

// One carrier's packages for the day (every carrier without one), each
// scanned or not.
export const fetchPickup = (warehouseId, date, carrier) =>
  get(`wms/pickup?${queryOf({ warehouse_id: warehouseId, date, carrier })}`);
